import { gql } from '@apollo/client';

export const ADD_USER_TO_ACCOUNT_MUTATION = gql(`
  mutation AddUserToAccount($input: AddUserToAccountInput!) {
    addUserToAccount(input: $input) {
      userId
    }
  }
`);

export const REINSTATE_USER_STATUS = gql(`
  mutation ReinstateUserStatus($input: ReinstateInput!) {
    reinstate(input: $input) {
      message
    }
  }
`);

export const UDPATE_USER_PERMISSIONS_MUTATION = gql(`
  mutation UpdateUserPermissions(
    $updateUserPermissionsInput: UpdateUserPermissionsInput!
  ) {
    updateUserPermissions(input: $updateUserPermissionsInput) {
      userId
      permissions {
        hasPremiumTalentSearch
        hasAllPositionAccess
        canCreatePosition
        hasAnalytics
        role
      }
    }
  }
`);

export const REMOVE_USER_FROM_ACCOUNT = gql(`
  mutation RemoveUserFromAccount($input: RemoveUserFromAccountInput!) {
    removeUserFromAccount(input: $input) {
      message
    }
  }
`);

export const SEND_PASSWORD_RESET_EMAIL = gql(`
  mutation SendPasswordResetEmail($input: SendPasswordResetEmailInput!) {
    sendPasswordResetEmail(input: $input) {
      message
    }
  }
`);

export const SEND_REGISTRATION_EMAIL = gql(`
  mutation SendRegistrationEmail($input: SendRegistrationEmailInput!) {
    sendRegistrationEmail(input: $input) {
      message
    }
  }
`);
